/** Isotipo de Alpaca POS (mismo dibujo que public/favicon.svg). */
export function AlpacaMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="15" fill="#0b8a7d" />
      <g fill="#ffffff">
        <ellipse cx="20.5" cy="15" rx="4" ry="8.5" transform="rotate(-16 20.5 15)" />
        <ellipse cx="43.5" cy="15" rx="4" ry="8.5" transform="rotate(16 43.5 15)" />
        <rect x="23" y="44" width="18" height="20" />
        <rect x="20" y="19" width="24" height="28" rx="12" />
      </g>
      <g fill="#c8e9e4">
        <ellipse cx="20.5" cy="15.5" rx="1.7" ry="5" transform="rotate(-16 20.5 15.5)" />
        <ellipse cx="43.5" cy="15.5" rx="1.7" ry="5" transform="rotate(16 43.5 15.5)" />
        <circle cx="24.5" cy="21" r="6" />
        <circle cx="32" cy="17" r="7.5" />
        <circle cx="39.5" cy="21" r="6" />
      </g>
      <ellipse cx="32" cy="42" rx="8.5" ry="6.5" fill="#e6f4f2" />
      <g fill="#064a44">
        <circle cx="26.5" cy="31.5" r="2.2" />
        <circle cx="37.5" cy="31.5" r="2.2" />
        <ellipse cx="29.6" cy="40.4" rx="1.2" ry="1" />
        <ellipse cx="34.4" cy="40.4" rx="1.2" ry="1" />
      </g>
      <path
        d="M29.3 44.2c1.6 1.5 3.8 1.5 5.4 0"
        fill="none"
        stroke="#064a44"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}
